var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.60692 4.73795c.13209-.52186.6674-.83912 1.19564-.70862l3.15494.77942c.5282.1305.8494.65931.7173 1.18116l-.7887 3.11662c-.1321.52187-.6674.83915-1.19566.70868-.52824-.13048-.84941-.65931-.71734-1.18117l.22639-.89456c-1.33381.7804-2.22766 2.21698-2.22766 3.85822 0 2.0283 1.36492 3.7441 3.23897 4.2951.5219.1534.8191.6958.6637 1.2114-.1553.5155-.7043.8091-1.22615.6557-2.68717-.7901-4.64835-3.2486-4.64835-6.1622 0-2.32153 1.24515-4.35429 3.11091-5.48419l-.78671-.19436c-.52824-.1305-.84938-.65934-.71728-1.1812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3931 18.262c-.1321.5219-.6674.8392-1.1956.7087l-3.1549-.7792c-.4838-.1195-.8011-.577-.7392-1.0658l.3944-3.1168c.0675-.5338.5602-.9124 1.1005-.8457s.9236.5536.8561 1.0873l-.1478 1.168c1.4948-.7329 2.5216-2.2569 2.5216-4.016 0-2.02824-1.365-3.74405-3.239-4.29506-.5219-.15345-.8191-.6958-.6637-1.21138.1553-.51558.7043-.80915 1.2262-.65571 2.6871.79008 4.6483 3.24857 4.6483 6.16215 0 2.3215-1.2451 4.3542-3.1107 5.4841l.7864.1942c.5283.1305.8495.6593.7174 1.1812z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.56a1a3f4ab783c725f87495eaa4b29a2.svg";